export default __webpack_public_path__ + "static/media/00.98a9cbf3.jpg";